import React, { useEffect, useState } from "react";
import "../../styles/Navbar.css";
import logo from "../../styles/logo.png";
import api from "../../api/api";
import { ENDPOINTS } from "../../api/endpoints";

function NavbarTalent() {
  const [faveCount, setFaveCount] = useState(0);
  const [error, setError] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newName, setNewName] = useState("");
  const [messagesData, setMessagesData] = useState({ totalCount: 0 });

  const [userId] = useState(localStorage.getItem("userId") || "");
  const [userName, setUserName] = useState(
    localStorage.getItem("userName") || ""
  );
  const [resumeName, setResumeName] = useState(
    localStorage.getItem("resumeName") || ""
  );

  const siteBaseUrl =
    process.env.REACT_APP_SITE_BASE_URL || window.location.origin;

  //  Fetch message counts
  useEffect(() => {
    if (!userId) return;
    const fetchMessages = async () => {
      try {
        const resp = await api.get(
          ENDPOINTS.getUserResumeMessagesWithCounts(),
          {
            params: { userId, pageNumber: 1, pageSize: 2 },
          }
        );
        setMessagesData(resp.data || { totalCount: 0 });
      } catch (err) {
        setError(err.message);
      }
    };
    fetchMessages();
  }, [userId]);

  //  Fetch resume name (on mount or login)
  useEffect(() => {
    const fetchResumeName = async () => {
      if (!userId) return;
      try {
        const resp = await api.get(ENDPOINTS.getUserName({ userId }));
        const name = resp.data?.userName || localStorage.getItem("userName");
        setResumeName(name);
        localStorage.setItem("resumeName", name);
      } catch (err) {
        console.error("Failed to fetch resume name:", err);
      }
    };
    fetchResumeName();
  }, [userId]);

  //  Fetch favorites count
  useEffect(() => {
    if (!userId) return;
    const fetchTalentProfile = async () => {
      try {
        const resp = await api.get(ENDPOINTS.getTalentProfile({ userId }));
        setFaveCount(resp.data?.data?.faveCount || 0);
      } catch (err) {
        setError(err.message);
      }
    };
    fetchTalentProfile();
  }, [userId]);

  //  Update resume name
  const handleUpdateName = async () => {
    if (!newName.trim() || !userId) return;
    setLoading(true);
    try {
      console.log("Attempting to update name:", newName, "for userId:", userId);
      await api.post(ENDPOINTS.updateResumeName({ userId, name: newName }));
      setResumeName(newName);
      setUserName(newName);
      setEditing(false);
      localStorage.setItem("userName", newName);
      localStorage.setItem("resumeName", newName);
      setError(null);
    } catch (err) {
      setError("Failed to update name: " + err.message);
    } finally {
      setLoading(false);
    }
  };

const handleLogout = () => {
  //  1. Preserve remembered username (if any)
  const rememberedUsername = localStorage.getItem("rememberedUsername");

  //  2. Clear storage
  localStorage.clear();
  sessionStorage.clear();

  //  3. Clear cookies
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
  });

  //  4. Restore remembered username
  if (rememberedUsername) {
    localStorage.setItem("rememberedUsername", rememberedUsername);
  }

  //  5. Redirect to login (full reload)
  window.location.replace("/login");
};

return (
  <nav className="navbar">
    <div className="navbar-container">
      <div className="navbar-left">
        <div className="logo">
          <img src={logo} alt="DirectSubmit Logo" className="logo-img" />
        </div>
      </div>
    </div>
  </nav>
);

}

export default NavbarTalent;
